import { Box, Typography } from '@mui/material';

export const ConfirmSectionTitle = ({
  title,
  count,
  color = '#1A1C20',
}: {
  title: string;
  count: number;
  color?: string;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'baseline', // Align to baseline instead of center
        gap: 1,
        mb: 2,
      }}
    >
      <Typography
        sx={{
          color: color,
          fontFamily: '"Noto Sans JP", sans-serif',
          fontSize: '22px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '28px',
          letterSpacing: 0,
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          borderRadius: '1000px',
          border: '1px solid rgba(0, 71, 186, 0.20)',
          background: 'rgba(0, 71, 186, 0.10)',
          display: 'inline-flex', // Use inline-flex to align with text baseline
          width: '50px',
          height: '30px',
          justifyContent: 'center',
          alignItems: 'center',
          verticalAlign: 'baseline', // Align to baseline
          position: 'relative',
          top: '1px', // Fine-tune vertical alignment with text baseline
        }}
      >
        <Typography
          sx={{
            color: '#0047BA',
            fontFamily: '"Noto Sans JP", sans-serif',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '1', // Use line-height 1 to ensure perfect vertical centering
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          {count}
        </Typography>
      </Box>
      <Typography
        sx={{
          color: color,
          fontFamily: '"Noto Sans JP", sans-serif',
          fontSize: '22px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '28px',
          letterSpacing: 0,
        }}
      >
        件
      </Typography>
    </Box>
  );
};
